import { EntityTaxVM } from './../../../models/entity';
import { AccountVM } from '../../../models/account';
import { Action } from '@ngrx/store';
import { ITaxStatus } from 'src/app/store/user/facade/user.facade';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';
import { IUserAddress } from '../../../models/userAddress';

export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_FAIL = 'GET_USER_PROFILE_FAIL';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const RESET_USER_PROFILE_FORM = 'RESET_USER_PROFILE_FORM';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_FAIL = 'UPDATE_USER_PROFILE_FAIL';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const USER_PROFILE_EDIT = 'USER_PROFILE_EDIT';
export const USER_PROFILE_EDIT_CLOSE = 'USER_PROFILE_EDIT_CLOSE';
export const SAVE_USER_PROFILE_TFA_TYPE_EMAIL = 'SAVE_USER_PROFILE_TFA_TYPE_EMAIL';
export const SAVE_USER_PROFILE_TFA_TYPE_EMAIL_SUCCESS = 'SAVE_USER_PROFILE_TFA_TYPE_EMAIL_SUCCESS';
export const SAVE_USER_PROFILE_TFA_TYPE_EMAIL_FAIL = 'SAVE_USER_PROFILE_TFA_TYPE_EMAIL_FAIL';
export const UPDATE_USER_PROFILE_TFA_TYPE_SMS = 'UPDATE_USER_PROFILE_TFA_TYPE_SMS';
export const SAVE_USER_PROFILE_TFA_TYPE_SMS = 'SAVE_USER_PROFILE_TFA_TYPE_SMS';
export const SAVE_USER_PROFILE_TFA_TYPE_SMS_FAIL = 'SAVE_USER_PROFILE_TFA_TYPE_SMS_FAIL';
export const SAVE_USER_PROFILE_TFA_TYPE_SMS_SUCCESS = 'SAVE_USER_PROFILE_TFA_TYPE_SMS_SUCCESS';
export const REQUEST_SMS_VERIFICATION = 'REQUEST_SMS_VERIFICATION';
export const REQUEST_SMS_VERIFICATION_SUCCESS = 'REQUEST_SMS_VERIFICATION_SUCCESS';
export const REQUEST_SMS_VERIFICATION_FAIL = 'REQUEST_SMS_VERIFICATION_FAIL';
export const VERIFY_SMS = 'VERIFY_SMS';
export const VERIFY_SMS_SUCCESS = 'VERIFY_SMS_SUCCESS';
export const VERIFY_SMS_FAIL = 'VERIFY_SMS_FAIL';
export const RESET_PROFILE_TFA = 'RESET_PROFILE_TFA';
export const TFA_STEP = 'TFA_STEP';
export const UPDATE_TFA = 'UPDATE_TFA';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';
export const GET_TAX_STATUS = 'GET_TAX_STATUS';
export const GET_TAX_STATUS_SUCCESS = 'GET_TAX_STATUS_SUCCESS';
export const GET_TAX_STATUS_FAIL = 'GET_TAX_STATUS_FAIL';
export const SET_TAX_STATUS = 'SET_TAX_STATUS';
export const SET_TAX_STATUS_SUCCESS = 'SET_TAX_STATUS_SUCCESS';
export const SET_TAX_STATUS_FAIL = 'SET_TAX_STATUS_FAIL';
export const RESET_SMS_VERIFICATION_STATUS = 'RESET_SMS_VERIFICATION_STATUS';
export const GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION = 'GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION';
export const GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_SUCCESS = 'GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_SUCCESS';
export const GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_FAIL = 'GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_FAIL';
export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAIL = 'GET_ADDRESS_FAIL';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_ADDRESS_SUCCESS = 'SET_ADDRESS_SUCCESS';
export const SET_ADDRESS_FAIL = 'SET_ADDRESS_FAIL';
@ShowLoader()
export class GetUserProfile implements Action {
    readonly type = GET_USER_PROFILE;
}

@HideLoader(GET_USER_PROFILE)
export class GetUserProfileFail implements Action {
    readonly type = GET_USER_PROFILE_FAIL;
    constructor(public payload: string) { }
}

@HideLoader(GET_USER_PROFILE)
export class SetUserProfile implements Action {
    readonly type = SET_USER_PROFILE;
    constructor(public payload: AccountVM) { }
}
export class ResetUserProfileForm implements Action {
    readonly type = RESET_USER_PROFILE_FORM;
}
export class UpdateUserProfile implements Action {
    readonly type = UPDATE_USER_PROFILE;
    constructor(public payload: any) { }
}
export class UpdateUserProfileFail implements Action {
    readonly type = UPDATE_USER_PROFILE_FAIL;
    constructor(public payload: string) { }
}
export class UpdateUserProfileSuccess implements Action {
    readonly type = UPDATE_USER_PROFILE_SUCCESS;
    constructor(public payload: {
        message: string,
        userProfile: AccountVM
    }) { }
}
export class UserProfileEdit implements Action {
    readonly type = USER_PROFILE_EDIT;
}
export class UserProfileEditClose implements Action {
    readonly type = USER_PROFILE_EDIT_CLOSE;
}
export class SaveUserProfileTFATypeEmail implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_EMAIL;
    constructor(public payload: any) { }
}
export class SaveUserProfileTFATypeEmailSuccess implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_EMAIL_SUCCESS;
}
export class SaveUserProfileTFATypeEmailFail implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_EMAIL_FAIL;
    constructor(public payload: string) { }
}
export class UpdateUserProfileTFATypeSMS implements Action {
    readonly type = UPDATE_USER_PROFILE_TFA_TYPE_SMS;
    constructor(public payload: number) { }
}
export class SaveUserProfileTFATypeSMS implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_SMS;
    constructor(public payload: string) { }
}
export class SaveUserProfileTFATypeSMSFail implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_SMS_FAIL;
    constructor(public payload: string) { }
}
export class SaveUserProfileTFATypeSMSSuccess implements Action {
    readonly type = SAVE_USER_PROFILE_TFA_TYPE_SMS_SUCCESS;
}
export class RequestSMSVerification implements Action {
    readonly type = REQUEST_SMS_VERIFICATION;
    constructor(public payload: {
        entityId: string;
        body: string
    }) { }
}
export class RequestSMSVerificationSuccess implements Action {
    readonly type = REQUEST_SMS_VERIFICATION_SUCCESS;
}
export class RequestSMSVerificationFail implements Action {
    readonly type = REQUEST_SMS_VERIFICATION_FAIL;
    constructor(public payload: string) { }
}
export class VerifySMS implements Action {
    readonly type = VERIFY_SMS;
    constructor(public payload: {
        userProfile: AccountVM,
        body: string;
    }) { }
}
export class VerifySMSSuccess implements Action {
    readonly type = VERIFY_SMS_SUCCESS;
    constructor(public payload: AccountVM) { }
}
export class VerifySMSFail implements Action {
    readonly type = VERIFY_SMS_FAIL;
    constructor(public payload: string) { }
}
export class ResetProfileTFA implements Action {
    readonly type = RESET_PROFILE_TFA;
}
export class TFAStep implements Action {
    readonly type = TFA_STEP;
    constructor(public payload: number) { }
}
export class UpdateTFA implements Action {
    readonly type = UPDATE_TFA;
    constructor(public payload: boolean) { }
}
export class GetTaxStatus implements Action {
    readonly type = GET_TAX_STATUS;
}
export class GetTaxStatusSuccess implements Action {
    readonly type = GET_TAX_STATUS_SUCCESS;
    constructor(public payload: ITaxStatus) { }
}
export class GetTaxStatusFail implements Action {
    readonly type = GET_TAX_STATUS_FAIL;
    constructor(public payload: string) { }
}
export class SetTaxStatus implements Action {
    readonly type = SET_TAX_STATUS;
    constructor(public payload: EntityTaxVM) { }
}
export class SetTaxStatusSuccess implements Action {
    readonly type = SET_TAX_STATUS_SUCCESS;
    constructor(public payload: ITaxStatus) { }
}
export class SetTaxStatusFail implements Action {
    readonly type = SET_TAX_STATUS_FAIL;
    constructor(public payload: string) { }
}
export class ResetSMSVerificationStatus implements Action {
    readonly type = RESET_SMS_VERIFICATION_STATUS;
}
export class GetUserRequiredToSetTwoFActorAuthentication implements Action {
    readonly type = GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION;
}
export class GetUserRequiredToSetTwoFactorAuthenticationSuccess implements Action {
    readonly type = GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_SUCCESS;
    constructor(public payload: boolean) { }
}
export class GetUserRequiredToSetTwoFactorAuthenticationFail implements Action {
    readonly type = GET_USER_REQUIRED_TO_SET_TWO_FACTOR_AUTHENTICATION_FAIL;
    constructor(public payload: string) { }
}

export class GetAddress implements Action {
    readonly type = GET_ADDRESS;
    constructor(public payload: string) { }    
}

export class GetAddressSuccess implements Action {
    readonly type = GET_ADDRESS_SUCCESS;
    constructor(public payload: IUserAddress) { }
}

export class GetAddressFail implements Action {
    readonly type = GET_ADDRESS_FAIL;
    constructor(public payload: string) { }
}

export class SetAddress implements Action {
    readonly type = SET_ADDRESS;
    constructor(public payload: {
        userId: string;
        body: IUserAddress
    }) { }
}

export class SetAddressSuccess implements Action {
    readonly type = SET_ADDRESS_SUCCESS;
    constructor(public payload: IUserAddress) { }
}

export class SetAddressFail implements Action {
    readonly type = SET_ADDRESS_FAIL;
    constructor(public payload: string) { }
}


export type UserActions
    = GetUserProfile | GetUserProfileFail | SetUserProfile | ResetUserProfileForm
    | UpdateUserProfile | UpdateUserProfileFail | UpdateUserProfileSuccess | UserProfileEdit | UserProfileEditClose
    | RequestSMSVerification | RequestSMSVerificationSuccess | RequestSMSVerificationFail
    | VerifySMS | VerifySMSSuccess | VerifySMSFail | ResetSMSVerificationStatus
    | SaveUserProfileTFATypeEmail | SaveUserProfileTFATypeEmailSuccess | SaveUserProfileTFATypeEmailFail
    | UpdateUserProfileTFATypeSMS | SaveUserProfileTFATypeSMS | SaveUserProfileTFATypeSMSFail | SaveUserProfileTFATypeSMSSuccess
    | ResetProfileTFA | TFAStep | UpdateTFA | GetTaxStatus | GetTaxStatusSuccess | GetTaxStatusFail | SetTaxStatus | SetTaxStatusSuccess | SetTaxStatusFail
    | GetUserRequiredToSetTwoFActorAuthentication | GetUserRequiredToSetTwoFactorAuthenticationSuccess | GetUserRequiredToSetTwoFactorAuthenticationFail
    | GetAddress | GetAddressSuccess | GetAddressFail | SetAddress | SetAddressSuccess | SetAddressFail;